import { getClearEmail } from 'utils/regex-utils';

/** Validation predicates of the auth form fields (PropsFormatter passes the field value) */
export const isEmailFilled = (value: unknown) => getClearEmail(typeof value === 'string' ? value : '') !== null;

/** Not blank: the backend checks @NotBlank */
export const isUsernameFilled = (value: unknown) => typeof value === 'string' && value.trim() !== '';
